import styles from '~/styles/_pricing.module.scss'

export const OverviewSection = () => {
  return (
    <section className={`${styles.overview} bg-white pt-3 pb-3 pb-md-6`}>
      <div className="mx-auto text-break" style={{ maxWidth: 490 }}>
        <h2 className={`${styles.h3} lh-base mb-5`}>
          Mathlogプレミアムプランとは
        </h2>
        <p className={styles.lead}>
          数学好きのみなさま向けに、共同編集や限定公開、LaTeXエクスポートなど、
          <br />
          今までよりも情報共有や学びの記録を自由にできる機能をご用意しました。
          <br />
          今後も、数学に没頭できる機能を次々と追加していきます。お楽しみに！
        </p>
      </div>
    </section>
  )
}
